var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "House"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5784 7.33448L9.95695 2.028L9.9457 2.01745C9.68736 1.78103 9.34985 1.6499 8.99965 1.6499C8.64945 1.6499 8.31194 1.78103 8.05359 2.01745L8.04164 2.028L2.42156 7.33448C2.27904 7.46634 2.16526 7.6262 2.08735 7.80405C2.00943 7.9819 1.96906 8.17391 1.96875 8.36808V14.8685C1.96875 15.2414 2.11691 15.5991 2.38063 15.8628C2.64435 16.1266 3.00204 16.2747 3.375 16.2747H6.75C7.12296 16.2747 7.48065 16.1266 7.74437 15.8628C8.00809 15.5991 8.15625 15.2414 8.15625 14.8685V11.7747H9.84375V14.8685C9.84375 15.2414 9.99191 15.5991 10.2556 15.8628C10.5194 16.1266 10.877 16.2747 11.25 16.2747H14.625C14.998 16.2747 15.3556 16.1266 15.6194 15.8628C15.8831 15.5991 16.0312 15.2414 16.0312 14.8685V8.36808C16.0309 8.17391 15.9906 7.9819 15.9127 7.80405C15.8347 7.6262 15.721 7.46634 15.5784 7.33448ZM14.3438 14.5872H11.5312V11.4935C11.5312 11.3088 11.4949 11.1259 11.4242 10.9553C11.3535 10.7847 11.25 10.6297 11.1194 10.4991C10.9888 10.3685 10.8338 10.2649 10.6631 10.1943C10.4925 10.1236 10.3097 10.0872 10.125 10.0872H7.875C7.50204 10.0872 7.14435 10.2354 6.88063 10.4991C6.61691 10.7628 6.46875 11.1205 6.46875 11.4935V14.5872H3.65625V8.48972L9 3.44479L14.3438 8.48972V14.5872Z",
    fill: "#19234F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.e74da901afed11028ee582f86fa3a799.svg";
export { ForwardRef as ReactComponent };